import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_2 = { class: "card card-custom gutter-b example example-compact w-100" }
const _hoisted_3 = { class: "card-header d-flex flex-column" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h1", { class: "mt-4" }, "Iniciar Laudo", -1)
const _hoisted_6 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fa fa-camera fs-2" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Enviar evidências ")
const _hoisted_9 = { class: "text-muted font-weight-bold font-size-sm my-1" }
const _hoisted_10 = { class: "text-muted mb-4 font-weight-bold font-size-sm" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Cliente: ")
const _hoisted_12 = { class: "text-dark font-weight-bold" }
const _hoisted_13 = {
  class: "accordion",
  id: "accordionLaudo"
}
const _hoisted_14 = {
  class: "accordion-header",
  id: "headingOne"
}
const _hoisted_15 = { class: "card-body position-relative mb-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Pergunta = _resolveComponent("Pergunta")

  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          (!_ctx.isCadastroNovo)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: { name: 'Cadastrar-evidencias-laudo' },
                  class: "btn btn-primary btn-primary d-flex align-items-center mt-4 me-4"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode("button", {
                  class: "btn btn-sm btn-link mt-4",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.excluir && _ctx.excluir(...args)))
                }, " Excluir ")
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("span", _hoisted_9, _toDisplayString(_ctx.analise.marca) + " - " + _toDisplayString(_ctx.analise.modelo) + " | " + _toDisplayString(_ctx.analise.placa), 1),
        _createVNode("span", _hoisted_10, [
          _hoisted_11,
          _createVNode("span", _hoisted_12, _toDisplayString(_ctx.analise.nome), 1)
        ])
      ]),
      _createVNode("div", _hoisted_13, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perguntas, (localizacao, indexPergunta) => {
          return (_openBlock(), _createBlock("div", {
            key: indexPergunta,
            class: "accordion-item"
          }, [
            _createVNode("h2", _hoisted_14, [
              _createVNode("button", {
                ref: 
                  el => {
                    _ctx.accordions.push(el);
                  }
                ,
                class: ["accordion-button bg-white text-dark fs-1 text-center", {
                  'bg-success':
                    _ctx.getNumeroRespostasPorLocalizacao(
                      localizacao.localizacao
                    ) === localizacao.items.length
                }],
                type: "button",
                "data-bs-toggle": "collapse",
                "data-bs-target": '#' + localizacao.localizacao.replace(' ', ''),
                "aria-expanded": "true",
                "aria-controls": localizacao.localizacao.replace(' ', '')
              }, _toDisplayString(localizacao.localizacao), 11, ["data-bs-target", "aria-controls"])
            ]),
            _createVNode("div", {
              id: localizacao.localizacao.replace(' ', ''),
              class: ["accordion-collapse collapse", { show: indexPergunta === 0 }],
              "aria-labelledby": "headingOne",
              "data-bs-parent": "#accordionLaudo"
            }, [
              _createVNode("div", _hoisted_15, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(localizacao.items, (item, index) => {
                  return (_openBlock(), _createBlock(_component_Pergunta, {
                    pergunta: item,
                    imagens: _ctx.getEvidencias(item.itemId),
                    analiseId: _ctx.analiseId,
                    key: index
                  }, null, 8, ["pergunta", "imagens", "analiseId"]))
                }), 128)),
                _createVNode("button", {
                  onClick: ($event: any) => (_ctx.enviarRespostas(localizacao, indexPergunta, $event)),
                  class: "\n                    btn btn-success\n                    position-absolute\n                    bottom-0\n                    start-50\n                    translate-middle-x\n                  "
                }, [
                  _createVNode("span", null, "Enviar respostas " + _toDisplayString(localizacao.localizacao), 1)
                ], 8, ["onClick"])
              ])
            ], 10, ["id"])
          ]))
        }), 128))
      ])
    ])
  ]))
}